/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { WebAppGetYoutubeIntegrationStatsSelfViewersQueryResponse, WebAppGetYoutubeIntegrationStatsSelfViewersPathParams, WebAppGetYoutubeIntegrationStatsSelfViewersQueryParams, WebAppGetYoutubeIntegrationStatsSelfViewers401, WebAppGetYoutubeIntegrationStatsSelfViewers403 } from "../models/WebAppGetYoutubeIntegrationStatsSelfViewers";

export function getWebAppGetYoutubeIntegrationStatsSelfViewersUrl(station: WebAppGetYoutubeIntegrationStatsSelfViewersPathParams["station"]) {
  const res = { method: 'GET', url: `/web-app/v1/youtube-stats/viewers/${station}/self` as const }
  return res
}

/**
 * @description Uses the station `youtubeChannelId`. Responds with 400 when it is not set, and 404 when the channel is not in the live-viewers catalog.
 * @summary Viewer time series for the station YouTube channel
 * {@link /web-app/v1/youtube-stats/viewers/:station/self}
 */
export async function webAppGetYoutubeIntegrationStatsSelfViewers(station: WebAppGetYoutubeIntegrationStatsSelfViewersPathParams["station"], params: WebAppGetYoutubeIntegrationStatsSelfViewersQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<WebAppGetYoutubeIntegrationStatsSelfViewersQueryResponse, ResponseErrorConfig<WebAppGetYoutubeIntegrationStatsSelfViewers401 | WebAppGetYoutubeIntegrationStatsSelfViewers403>, unknown>({ method : "GET", url : getWebAppGetYoutubeIntegrationStatsSelfViewersUrl(station).url.toString(), params, ... requestConfig })
  return res.data
}